import { Box, IconButton, Tooltip } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { BlockClicks } from "lib/@components/block-clicks"
import { alert } from "lib/@dialogs/alert"
import Iconify from "minimals-template/components/Iconify"
import { RegimeDraftLockTooltip } from "routes/regime/regime-draft-locking/regime-draft-lock-tooltip"

// The "add justification" affordance for an intro subject — mirrors the task JustifyTailoringButton.
// Hidden once a justification exists (the card takes over); disabled until the subject is changed.
export function IntroJustifyButton() {
    const {
        subjectId,
        subjectTitle,
        tailored,
        tailoringAudit,
        setJustification,
        commentReason,
        pendingChange,
        isEditable = true,
    } = useBoundContext()

    if (!isEditable || tailoringAudit?.payload?.reason) return null

    return (
        <Box sx={{ position: "absolute", top: 4, right: 4, zIndex: 2 }}>
            <BlockClicks>
                <RegimeDraftLockTooltip>
                    <Tooltip title={getTooltip()}>
                        <span>
                            <IconButton
                                aria-label="Add justification"
                                color="primary"
                                onClick={handleClick}
                                size="small"
                                disabled={!tailored}
                                data-cy={`intro-justification-button-${subjectId}`}
                            >
                                <Iconify icon="iconoir:chat-plus-in" />
                            </IconButton>
                        </span>
                    </Tooltip>
                </RegimeDraftLockTooltip>
            </BlockClicks>
        </Box>
    )

    function getTooltip() {
        if (!tailored) return "Nothing to justify"
        if (commentReason) return "Pre-filled from the comment. Edit it or leave it as is"
        return `Add justification for ${subjectTitle}`
    }

    async function handleClick() {
        if (!tailored) return
        if (pendingChange) {
            await alert(
                "Please wait until schedule updates are saved before adding a justification.",
                "Schedule Updating"
            )
            return
        }
        setJustification({ reason: commentReason })
    }
}
